import React, { useEffect, useState } from 'react'
import Item from '../Item/Item'
import { backend_url } from '../../App'

const AllProducts = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllProducts = () => {
      fetch(`${backend_url}/allproducts`)
        .then((res) => res.json())
        .then((data) => {
          setAllProducts(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching products:', err);
          setLoading(false);
        });
    };

    fetchAllProducts();
  }, []);

  return (
    <section className='relative py-[120px] px-[8%] overflow-hidden bg-[#060c18]'>
      {/* Background accents */}
      <div className="absolute top-1/3 -left-[200px] w-[600px] h-[600px] rounded-full blur-[120px] opacity-10 pointer-events-none" style={{ background: 'radial-gradient(circle, #7c3aed 0%, transparent 70%)' }} />
      <div className="absolute bottom-0 -right-[150px] w-[500px] h-[500px] rounded-full blur-[100px] opacity-10 pointer-events-none" style={{ background: 'radial-gradient(circle, #00d4ff 0%, transparent 70%)' }} />

      <div className="max-w-[1400px] mx-auto relative z-10">
        {/* Header section */}
        <div className="mb-20 text-center">
          <div className="mb-6">
            <span className="inline-block bg-gradient-to-r from-[rgba(0,212,255,0.15)] to-[rgba(124,58,237,0.15)] text-[#00d4ff] border border-[rgba(0,212,255,0.3)] px-5 py-2 rounded-full text-[11px] font-bold tracking-[3px] uppercase mb-6 backdrop-blur-sm">
              🛍️ Complete Catalog
            </span>
          </div>
          
          <h2 className="text-[56px] font-black text-white mb-4 -tracking-[1.2px] leading-[1.1] max-[900px]:text-[42px] max-[600px]:text-[32px]">
            All <span className="bg-gradient-to-r from-[#00d4ff] via-[#7c3aed] to-[#ec4899] bg-clip-text text-transparent drop-shadow-[0_0_20px_rgba(0,212,255,0.3)]">Products</span>
          </h2>
          
          <p className="text-[#6b7a8d] text-[18px] leading-[1.7] mt-4 max-w-[600px] mx-auto max-[600px]:text-base">
            Discover our complete collection of premium tech products. From laptops to accessories, find everything you need in one place.
          </p>

          {/* Stats */}
          <div className="flex items-center justify-center gap-8 mt-10 flex-wrap">
            <div className="flex flex-col items-center">
              <span className="text-4xl font-black text-[#00d4ff]">{allProducts.length}+</span>
              <span className="text-[#6b7a8d] text-sm mt-1">Products Available</span>
            </div>
            <div className="w-px h-12 bg-white/10 max-[600px]:hidden" />
            <div className="flex flex-col items-center">
              <span className="text-4xl font-black text-[#7c3aed]">100%</span>
              <span className="text-[#6b7a8d] text-sm mt-1">Original & Authentic</span>
            </div>
            <div className="w-px h-12 bg-white/10 max-[600px]:hidden" />
            <div className="flex flex-col items-center">
              <span className="text-4xl font-black text-[#f59e0b]">30K+</span>
              <span className="text-[#6b7a8d] text-sm mt-1">Happy Customers</span>
            </div>
          </div>

          {/* Decorative line */}
          <div className="w-24 h-[4px] bg-gradient-to-r from-[#00d4ff] via-[#7c3aed] to-transparent rounded-full mx-auto mt-8" />
        </div>

        {/* Loading state */}
        {loading && (
          <div className="flex items-center justify-center py-20">
            <div className="animate-spin">
              <div className="w-12 h-12 rounded-full border-4 border-[#3d4f66] border-t-[#00d4ff]" />
            </div>
          </div>
        )}

        {/* Products grid */}
        {!loading && allProducts.length > 0 && (
          <div className="grid grid-cols-4 gap-6 w-full max-[1300px]:grid-cols-3 max-[900px]:grid-cols-2 max-[600px]:grid-cols-2">
            {allProducts.map((item, index) => (
              <div key={index} className="animate-fade-in" style={{ animationDelay: `${index * 30}ms` }}>
                <Item 
                  id={item.id} 
                  name={item.name} 
                  image={item.image} 
                  new_price={item.new_price} 
                  old_price={item.old_price} 
                />
              </div>
            ))}
          </div>
        )}

        {/* Empty state */}
        {!loading && allProducts.length === 0 && (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="text-6xl mb-4">📭</div>
            <p className="text-[#6b7a8d] text-lg">No products found</p>
          </div>
        )}
      </div>

      {/* CSS for fade-in animation */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fadeIn 0.5s ease-out forwards;
        }
      `}</style>
    </section>
  )
}

export default AllProducts
